import React, { createContext, useContext, useState, ReactNode } from "react";

interface User {
    firstName: string;
    lastName: string;
}

interface AuthContextType {
    user: User;
    login: (firstName: string, lastName: string) => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [user, setUser] = useState<User>({ firstName: "", lastName: "" });

    const login = (firstName: string, lastName: string) => {
        setUser({ firstName, lastName });
    };

    const logout = () => {
        setUser({ firstName: "", lastName: "" });
    };

    return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
};
